var map = {
	"./ar.json": 5310,
	"./cn.json": 85556,
	"./de.json": 95894,
	"./en.json": 44174,
	"./es.json": 46725,
	"./hi.json": 53134,
	"./id.json": 35176,
	"./jp.json": 93679,
	"./ko.json": 19423,
	"./my.json": 7243,
	"./ph.json": 1153,
	"./pt.json": 37741,
	"./rs.json": 2774,
	"./th.json": 67549,
	"./vn.json": 85809,
	"./zh.json": 79527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89628;